var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaliforniaCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 155,
    viewBox: "0 0 154 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23_69)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 64,
    r: 64,
    fill: "#07587F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_23_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2507 105.625L79.4125 105.52L78.3656 103.321H78.6796L80.2507 105.625ZM71.035 101.54L71.663 101.645V101.959L70.6161 101.54H71.035ZM80.2507 100.179L80.4599 101.017H79.6222L78.2608 99.7597L80.2507 100.179ZM66.8459 94.8378L67.0551 95.4663L66.0082 96.0943L65.2748 94.8378H66.8459ZM64.7517 94.6286V94.8378L63.7043 94.6286L64.1231 94.3141L64.7517 94.6286ZM68.5213 94.4189L70.5113 94.3141L70.7204 94.6286L68.731 95.2566L67.5788 94.3141L68.5213 94.4189ZM65.6937 30.8518L66.0082 48.5499L107.793 83.5278L110.411 88.1357L112.401 89.3922L109.469 92.9527L109.678 96.8277L108.107 98.0843L109.05 101.226L110.62 101.959L110.515 104.158L90.1993 107.719L89.3616 106.462L90.1993 106.671L89.9896 106.043L89.0471 106.462L88.4191 102.692L86.534 100.179L81.6121 96.8277L79.6222 96.9326L78.6796 94.4189L76.3757 94.6286L73.8626 93.7904L72.5012 92.2198L69.9876 90.9633L63.1806 90.5445L62.1332 89.9159V84.2606L60.1438 83.737V81.8524L57.2113 79.6528L55.4311 76.616L52.7083 73.8932L52.0797 70.9607L52.9174 70.7516L53.4411 68.8665L52.3943 67.7142H50.7183L49.3569 66.1437L47.7864 62.4784V60.0696L48.7289 59.7556L48.8332 61.6407L50.7183 63.0021H51.4517L50.2995 60.4884L49.3569 59.7556L48.7289 58.1845L48.9381 57.7656L49.9855 57.6608L50.5092 57.7656H53.9648L54.2788 56.8231L55.8499 57.7656L54.5934 56.8231L53.4411 57.6608L53.9648 56.7183L52.2894 57.6608L51.4517 56.7183L50.4043 57.6608L48.7289 56.6139L47.7864 56.7183L48.3095 59.0222L47.7864 59.5459L44.7492 57.2419L44.2256 58.0802L44.435 55.8806L45.4823 56.8231L43.4925 53.5766L39.1988 49.0736V47.503L38.4658 44.9894L38.8847 42.0575L37.628 39.3341L34.9052 37.0305L34.8004 35.2502L35.5335 32.7368L36.7902 31.4802L36.1618 32.2132L37.4185 25.9298L36.6855 23.6259L36.1618 22.6834L36.2666 20.7983H65.5894L65.6937 30.8518Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23_69",
    x: 0.9,
    y: 0,
    width: 152.2,
    height: 154.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_23_69",
    x: 25.5004,
    y: 16.4983,
    width: 90.2001,
    height: 99.5204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_69",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaliforniaCircle);
export default __webpack_public_path__ + "static/media/CaliforniaCircle.3d6d857a4359143cb9073c2046eb7852.svg";
export { ForwardRef as ReactComponent };